import type { MetroSystem } from "@-/dev.improve.haniverse.data.china-transport";

// Rates for the legs no timetable covers: coach buses, and local transit between the districts
// of a shared-hub region. Everything else is priced from real timetables (see data/china-transport).

/** Road distance over great-circle distance, for coach buses. */
export const ROAD_DETOUR_FACTOR = 1.3;
/** Track distance over great-circle distance, for local metro rides. */
export const METRO_DETOUR_FACTOR = 1.3;

/**
 * Long-distance coach fares. Chongqing DRC's published expressway coach rates are ¥0.12–0.20/km
 * (high-grade coach) and ¥0.15/km (sleeper coach):
 * https://www.fzggw.cq.gov.cn/zwxx/bmdt/202002/t20200212_5205113.html
 */
export const COACH_FARE_PER_KM = 0.16;
export const SLEEPER_COACH_FARE_PER_KM = 0.15;
export const SLEEPER_COACH_MIN_KM = 600;
export const COACH_MIN_FARE = 15;
/** Average expressway coach speed, plus boarding. */
export const COACH_SPEED_KMH = 70;
export const COACH_OVERHEAD_MINUTES = 30;
/** Coaches cross Qiongzhou Strait to Hainan on the Xuwen–Haikou ferry. */
export const HAINAN_FERRY_MINUTES = 90;
export const COACH_MIN_KM = 20;
export const COACH_MAX_KM = 1500;

/** Changing between legs of a multi-leg journey. */
export const TRANSFER_MINUTES = 30;

export const METRO_SPEED_KMH = 35;
export const METRO_OVERHEAD_MINUTES = 10;
/** Shorter hops between districts are walked or folded into the next leg. */
export const METRO_MIN_KM = 3;

/**
 * Local transit fare by system and distance.
 * - Beijing (https://fgw.beijing.gov.cn/bmcx/djcx/cxldj/202003/t20200331_1752788.htm): ≤6 km ¥3,
 *   ≤12 ¥4, ≤22 ¥5, ≤32 ¥6, then +¥1 per 20 km.
 * - Shanghai: ≤6 km ¥3, ≤16 ¥4, then +¥1 per 10 km.
 * - Tianjin (https://fzgg.tj.gov.cn/zwgk_47325/jytabl/bljggk/202009/t20200922_3782103.html): ¥2–5.
 */
export function metroFareCny(system: MetroSystem, km: number): number {
  switch (system) {
    case "beijing": {
      return km <= 6
        ? 3
        : km <= 12
          ? 4
          : km <= 22
            ? 5
            : km <= 32
              ? 6
              : 6 + Math.ceil((km - 32) / 20);
    }
    case "shanghai": {
      return km <= 6 ? 3 : km <= 16 ? 4 : 4 + Math.ceil((km - 16) / 10);
    }
    case "tianjin": {
      return km <= 5 ? 2 : km <= 10 ? 3 : km <= 16 ? 4 : 5;
    }
  }
}

export function coachFareCny(roadKm: number): number {
  const rate = roadKm >= SLEEPER_COACH_MIN_KM ? SLEEPER_COACH_FARE_PER_KM : COACH_FARE_PER_KM;
  return Math.max(COACH_MIN_FARE, Math.round(roadKm * rate));
}
